//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
export default {
  name: 'NsTab',
  props: {
    isSelected: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    handleMouseenter() {
      this.$emit('mouseenter');
    },
  },
};
